import AddCircle from '@mui/icons-material/AddCircle'
import RemoveCircle from '@mui/icons-material/RemoveCircle'
import { IconButton, Stack, Typography } from '@mui/material'

import React from 'react'

type Props = {
  quantity: number
  size?: 'small' | 'medium' | 'large'
  onChange?: (newValue: number) => void
  min?: number
  max?: number
  disabled?: boolean
  decreaseDataCy?: string
  increaseDataCy?: string
}

const QuantitySelect: React.FC<Props> = ({
  quantity,
  size = 'medium',
  min = 0,
  max,
  disabled,
  decreaseDataCy,
  increaseDataCy,
  onChange = () => {},
}) => {
  return (
    <Stack alignItems="center" direction="row">
      {!disabled && (
        <IconButton
          data-cy={decreaseDataCy}
          edge="start"
          disabled={disabled || quantity === min}
          size={size}
          onClick={() => onChange(quantity - 1)}>
          <RemoveCircle fontSize={size} />
        </IconButton>
      )}
      <Typography fontSize={size} textAlign="center" minWidth="1.5em" variant="body2">
        {quantity}
      </Typography>
      {!disabled && (
        <IconButton
          data-cy={increaseDataCy}
          disabled={disabled || Boolean(typeof max === 'number' && quantity === max)}
          size={size}
          onClick={() => onChange(quantity + 1)}>
          <AddCircle fontSize={size} />
        </IconButton>
      )}
    </Stack>
  )
}

export default QuantitySelect
